import React, { useState, useEffect } from "react";
import { Button, Form, Input, Modal, message } from "antd";

const RejectModal = ({ 
  visible, 
  onCancel, 
  onSubmit, 
  record, 
  loading = false 
}) => {
  const [rejectForm] = Form.useForm();

  // Reset form when modal opens/closes
  useEffect(() => {
    if (visible) {
      rejectForm.resetFields();
    }
  }, [visible, rejectForm]);

  const handleSubmit = async () => {
    try {
      const values = await rejectForm.validateFields();
      
      const formattedValues = {
        caseId: record?.id,
        rejectRemark: values.rejectRemark,
        rejectBy: sessionStorage.getItem("id"),
      };

      await onSubmit(formattedValues);
      
      // Reset form
      rejectForm.resetFields();
    } catch (error) {
      // Validation error is handled by form
      if (error.errorFields) {
        return;
      }
      message.error('ไม่สามารถ reject/cancel ได้');
    }
  };

  const handleCancel = () => {
    rejectForm.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Reject/Cancel"
      open={visible}
      onOk={handleSubmit}
      onCancel={handleCancel}
      width={600}
      okText="ยืนยัน"
      cancelText="ยกเลิก"
      okButtonProps={{ danger: true, loading: loading }}
    >
      <Form form={rejectForm} layout="vertical">
        <Form.Item
          name="rejectRemark"
          label="Note"
          rules={[
            { required: true, message: "กรุณากรอก Note!" },
          ]}
        >
          <Input.TextArea
            rows={4}
            placeholder="กรุณาระบุเหตุผลในการ reject/cancel..."
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RejectModal;

